var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPantoneSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 4.83333V12.9896L4.68833 19.1883C4.00832 19.8675 3.62585 20.7889 3.625 21.75V4.83333C3.625 4.51286 3.75231 4.20552 3.97891 3.97891C4.20552 3.75231 4.51286 3.625 4.83333 3.625H9.66667C9.98714 3.625 10.2945 3.75231 10.5211 3.97891C10.7477 4.20552 10.875 4.51286 10.875 4.83333Z",
    fill: "#2CA9BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 21.75C3.625 20.7886 4.00692 19.8666 4.68674 19.1867C5.36656 18.5069 6.28859 18.125 7.25 18.125H24.1667C24.4871 18.125 24.7945 18.2523 25.0211 18.4789C25.2477 18.7055 25.375 19.0129 25.375 19.3333V24.1667C25.375 24.4871 25.2477 24.7945 25.0211 25.0211C24.7945 25.2477 24.4871 25.375 24.1667 25.375H7.25C6.28859 25.375 5.36656 24.9931 4.68674 24.3133C4.00692 23.6334 3.625 22.7114 3.625 21.75Z",
    fill: "#2CA9BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 21.75V4.83333C3.625 4.51286 3.75231 4.20552 3.97891 3.97891C4.20552 3.75231 4.51286 3.625 4.83333 3.625H9.66667C9.98714 3.625 10.2945 3.75231 10.5211 3.97891C10.7477 4.20552 10.875 4.51286 10.875 4.83333V13.0017",
    stroke: "#494949",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75165 18.1251L16.6266 7.25006C16.853 7.025 17.1593 6.89868 17.4785 6.89868C17.7977 6.89868 18.104 7.025 18.3304 7.25006L21.75 10.6455C21.975 10.8719 22.1014 11.1781 22.1014 11.4973C22.1014 11.8166 21.975 12.1228 21.75 12.3492L15.9983 18.1251",
    stroke: "#494949",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 21.75C3.625 20.7886 4.00692 19.8666 4.68674 19.1867C5.36656 18.5069 6.28859 18.125 7.25 18.125H24.1667C24.4871 18.125 24.7945 18.2523 25.0211 18.4789C25.2477 18.7055 25.375 19.0129 25.375 19.3333V24.1667C25.375 24.4871 25.2477 24.7945 25.0211 25.0211C24.7945 25.2477 24.4871 25.375 24.1667 25.375H7.25C6.28859 25.375 5.36656 24.9931 4.68674 24.3133C4.00692 23.6334 3.625 22.7114 3.625 21.75Z",
    stroke: "#494949",
    strokeWidth: 2.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantoneSvgrepocom);
export default __webpack_public_path__ + "static/media/pantone_svgrepo.com.dd01705420ca1887c742348b0c9681e6.svg";
export { ForwardRef as ReactComponent };